<script setup>
  const props = defineProps({
    tooltip: {
      type: String,
      default: '',
    },
    filtered: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: Number,
      default: 14,
    },
  });
</script>

<template>
  <div
    class="ui-title"
    :style="{fontSize: fontSize + 'px'}"
  >
    <slot />
    <template v-if="tooltip">
      <ElTooltip
        :content="tooltip"
        placement="top"
        :show-after="300"
        :hide-after="200"
        popper-class="ui-title__tooltip"
      >
        <UiIcon
          :size="14"
          name="question-circle"
          color="var(--tooltip-icon)"
          class="ui-title__icon ui-title__icon_question"
        />
      </ElTooltip>
    </template>
    <template v-if="filtered">
      <UiIcon
        :size="14"
        name="filter"
        color="var(--tooltip-icon)"
        class="ui-title__icon"
      />
    </template>
  </div>
</template>

<style lang="scss">
.ui-title {
  display: flex;
  align-items: center;
  line-height: 1;
  &__icon{
    margin-left: 4px;
    &_question{
      cursor: help;
    }
  }
  &__tooltip {
    z-index: 3000 !important;
  }
}
</style>
